import type { ComponentProps } from "react";

type SvgProps = ComponentProps<"svg">;

const EventCommunity = (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 3.33333C1.5 2.32081 2.32081 1.5 3.33333 1.5H12.6667C13.6792 1.5 14.5 2.32081 14.5 3.33333V10C14.5 11.0125 13.6792 11.8333 12.6667 11.8333H5.3075C5.05436 11.8333 4.81493 11.9484 4.65677 12.1461L3.10279 14.0885C2.57135 14.7529 1.5 14.3771 1.5 13.5263V3.33333ZM6.32066 7.16667C6.28203 7.22927 6.23648 7.2958 6.18333 7.36667C5.95882 7.666 5.65298 7.97327 5.31311 8.31313C5.11785 8.5084 5.11785 8.82493 5.31311 9.0202C5.50837 9.21547 5.82496 9.21547 6.02022 9.0202L6.03461 9.0058C6.35758 8.68287 6.71187 8.3286 6.98333 7.96667C7.25487 7.6046 7.5 7.16313 7.5 6.66667V5.33333C7.5 4.68901 6.97767 4.16667 6.33333 4.16667H5.66667C5.02234 4.16667 4.5 4.68901 4.5 5.33333V6C4.5 6.64433 5.02234 7.16667 5.66667 7.16667H6.32066ZM10.1833 7.36667C10.2365 7.2958 10.2821 7.22927 10.3207 7.16667H9.66667C9.02233 7.16667 8.5 6.64432 8.5 6V5.33333C8.5 4.68901 9.02233 4.16667 9.66667 4.16667H10.3333C10.9777 4.16667 11.5 4.68901 11.5 5.33333V6.66667C11.5 7.16313 11.2549 7.6046 10.9833 7.96667C10.7119 8.3286 10.3576 8.68287 10.0346 9.0058L10.0202 9.0202C9.82493 9.21547 9.5084 9.21547 9.31313 9.0202C9.11787 8.82493 9.11787 8.5084 9.31313 8.31313C9.653 7.97327 9.9588 7.666 10.1833 7.36667Z"
      fill="currentColor"
    />
  </svg>
);

export default EventCommunity;
